(function () {
  'use strict';

  function init(tablist) {
    if (!tablist || tablist.dataset.gefTabsReady === 'true') return;
    tablist.dataset.gefTabsReady = 'true';

    var tabs = Array.prototype.slice.call(tablist.querySelectorAll('[role=tab]'));
    var panels = Array.prototype.slice.call(tablist.querySelectorAll('[role=tabpanel]'));
    var mobileMq = window.matchMedia ? window.matchMedia('(max-width: 767px)') : { matches: false };

    function isMobile() {
      return !!mobileMq.matches;
    }

    function syncMode() {
      if (isMobile()) {
        panels.forEach(function (panel, index) {
          panel.hidden = false;
          panel.classList.add('is-active');
          var details = panel.querySelector('.gef-cd-tabs__acc-wrap');
          if (details) details.open = index === 0;
        });
        return;
      }
      var active = tabs.find(function (tab) { return tab.classList.contains('is-active'); }) || tabs[0];
      if (active) activate(active, false);
    }

    function activate(tab, shouldScroll) {
      var target = tab.getAttribute('data-tab-target');
      tabs.forEach(function (item) {
        var active = item === tab;
        item.setAttribute('aria-selected', active ? 'true' : 'false');
        item.setAttribute('tabindex', active ? '0' : '-1');
        item.classList.toggle('is-active', active);
      });
      panels.forEach(function (panel) {
        var active = panel.getAttribute('data-tab-panel') === target;
        panel.hidden = !active;
        panel.classList.toggle('is-active', active);
      });
      if (shouldScroll) {
        var panel = tablist.querySelector('[data-tab-panel="' + target + '"]');
        if (panel && panel.scrollIntoView) panel.scrollIntoView({ block: 'start', behavior: 'smooth' });
      }
    }

    function activateTarget(target) {
      var targetTab = tabs.find(function (tab) {
        return tab.getAttribute('data-tab-target') === target;
      });
      if (!targetTab) return;
      if (isMobile()) {
        var panel = tablist.querySelector('[data-tab-panel="' + target + '"]');
        var details = panel && panel.querySelector('.gef-cd-tabs__acc-wrap');
        if (details) details.open = true;
        if (panel && panel.scrollIntoView) panel.scrollIntoView({ block: 'start', behavior: 'smooth' });
      } else {
        activate(targetTab, true);
      }
    }

    tabs.forEach(function (tab, index) {
      tab.addEventListener('click', function () { activate(tab, false); });
      tab.addEventListener('keydown', function (event) {
        var nextIndex = index;
        if (event.key === 'ArrowRight') nextIndex = (index + 1) % tabs.length;
        else if (event.key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length;
        else if (event.key === 'Home') nextIndex = 0;
        else if (event.key === 'End') nextIndex = tabs.length - 1;
        else return;
        event.preventDefault();
        tabs[nextIndex].focus();
        activate(tabs[nextIndex], false);
      });
    });

    tablist.querySelectorAll('[data-tab-jump]').forEach(function (button) {
      button.addEventListener('click', function () {
        activateTarget(button.getAttribute('data-tab-jump'));
      });
    });

    if (mobileMq.addEventListener) mobileMq.addEventListener('change', syncMode);
    else if (mobileMq.addListener) mobileMq.addListener(syncMode);
    syncMode();
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-gef-cd-tabs]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); }, { once: true });
  } else {
    boot(document);
  }
  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target || document);
  });
})();
